// extracted by mini-css-extract-plugin
module.exports = {"iconDown":"DropdownIcon_iconDown_1Em9h"};